
import {omit} from 'external/lodash'
import { ComponentProps, React, useContext, FC } from 'external/react'

import { TeacherContext } from 'teacher/context'

type CountLabelProps = {
    count: number,
    label: string
} & ComponentProps<"div">


const CountLabel: FC<CountLabelProps> = (props) => {
  const {count, label} = props
  const {translate} = useContext(TeacherContext) as any
  return (
    <div {...omit(props, ['count','label'])}>
      <label className="value">
        {count}
      </label>
      <label className="label">
        {translate(label)}
      </label>
    </div>
  )
}
export default CountLabel